export enum ChannelNonLinearProcessingLevel {
	Auto = 'AUTO',
	Low = 'LOW',
	Medium = 'MEDIUM',
	High = 'HIGH'
}
